import React from 'react'
import Dashboard from '../Dashboard';
import PlanATripSuccessMain from './PlanATripSuccessMain'

export default function PlanATripSuccess() {
    return (
        <div>
            <Dashboard cmp={<PlanATripSuccessMain />} />
        </div>
    )
}
